import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import style from './style.less'
import classNames from 'classnames'
import Icon from '@yaak/components/src/Icon'

export interface SearchBarProps {
  placeholder?: string
  setSearchQuery: Dispatch<SetStateAction<string>>
  clear?: boolean
  fullWidth?: boolean
  debounce?: number
}

const SearchBar = ({
  setSearchQuery,
  placeholder,
  clear,
  fullWidth,
  debounce = 800,
}: SearchBarProps) => {
  const [query, setQuery] = useState('')
  const [placeholderText, setPlaceholderText] = useState(placeholder)
  const isFirstRender = useRef(true)

  useEffect(() => {
    setPlaceholderText(placeholder)
  }, [placeholder])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const handler = setTimeout(() => {
      setSearchQuery(query.trim())
    }, debounce)

    return () => {
      clearTimeout(handler)
    }
  }, [query, debounce, setSearchQuery])

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const element = e.target as HTMLInputElement
    setQuery(element.value)
  }
  return (
    <div
      className={classNames(
        style.searchBar,
        fullWidth ? style.searchBarFull : undefined
      )}
    >
      <Icon name={'Search'} styles={{ fontSize: '1.25rem' }} />
      <input
        id={'searchInput'}
        value={query}
        placeholder={placeholderText}
        onChange={handleChange}
        onClick={() => setPlaceholderText('')}
        onBlur={() => setPlaceholderText(placeholder)}
      />
      {clear && query && (
        <Icon
          styles={{ fontSize: '1.25rem' }}
          name={'Close'}
          onClick={() => {
            setQuery('')
            setSearchQuery('')
          }}
          className={style.clearIcon}
        />
      )}
    </div>
  )
}

export default SearchBar
